module.exports = __webpack_public_path__ + "static/media/imgLogo.8c2772f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/imgLogo.png
// module id = 468
// module chunks = 0